import { useCommonData } from '@/hooks';
import EMPTY_NEWS_COVER from '@/assets/images/empty_news_cover.png';
import EMPTY_NEWS_COVER_IN_SURF from '@/assets/images/empty_news_cover_in_surf.png';
import EMPTY_EVENT_COVER from '@/assets/images/empty_event_cover.png';
import EMPTY_EVENT_COVER_169 from '@/assets/images/empty_event_cover_169.png';

const MODULE_DEFAULT_COVERS = {
	'news': EMPTY_NEWS_COVER,
	'investment_activity': EMPTY_EVENT_COVER,
	'investment_activity_169': EMPTY_EVENT_COVER_169,
	'surf_news': EMPTY_NEWS_COVER_IN_SURF
};

export function useModuleDefaultCover() {
	const { getColumnData } = useCommonData();

	const getDefaultCover = moduleId => {
		// 投关活动 不展示配置的默认封面
		if (moduleId === 'investment_activity') return EMPTY_EVENT_COVER;

		const { coverPicture, coverPictureSwitch } = getColumnData.value;
		const defaultCover = coverPictureSwitch
			? coverPicture || MODULE_DEFAULT_COVERS[moduleId]
			: MODULE_DEFAULT_COVERS[moduleId];

		return defaultCover;
	};

	return {
		getDefaultCover
	};
}
